import React from "react";

const DashboardStyles02 = () => (
   <style jsx>{`
  html, body, #root {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden !important;
  }

  * {
    box-sizing: border-box;
  }

  wrapper: {
    display: "flex",
    minHeight: "100vh",
    backgroundColor: "#f8fafc",
    font-family: "Poppins", sans-serif,
    overflowX: "hidden",   // ✅ ADD
  },
 main: {
  flexGrow: 1,
  width: "100%",
  overflowX: "hidden",
  paddingTop: "110px",   // 🔥 IMPORTANT (header height + gap)
},

  graphCell: {
    minHeight: 210,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",   // 🔥 equal top-bottom spacing
    padding: "20px 10px",
    background: "transparent",
  },

  profileBadge: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    background: "rgba(255,255,255,0.1)",
    padding: "8px 15px",
    borderRadius: "50px",
    maxWidth: "180px",   // ✅ ADD
  },
  {
    color: "#fff",
    fontWeight: "300",
    fontSize: "14px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "110px",   // ✅ prevents cut
  }
  header: {
    height: "90px",
    background: "#410c47",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 20px",   // 🔁 40 → 20
    position: "sticky",
    top: 0,
    zIndex: 100,
    overflowX: "hidden", // ✅ ADD
  },
  searchBar: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    backgroundColor: "rgba(255,255,255,0.15)",
    padding: "10px 16px",
    borderRadius: "15px",
    width: "180px",       // 🔁 250 → 180
    maxWidth: "60vw",     // ✅ ADD
  },


          .mobile-close-icon {
            display: none;
            cursor: pointer;
            color: #fff;
          }
          .nav-item {
            padding: 15px 20px;
            border-radius: 15px;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 15px;
            color: #a78bfa;
            font-weight: 700;
            transition: 0.3s;
          }
          .nav-item:hover {
            background: rgba(139, 92, 246, 0.1);
            color: #fff;
            transform: translateX(5px);
          }
          .nav-item.active {
            background: #8b5cf6;
            color: #fff;
            box-shadow: 0 10px 20px rgba(139, 92, 246, 0.2);
          }
          @media (max-width: 1024px) {
            .mobile-only {
              display: block;
            }
            .mobile-close-icon {
              display: block;
            }
            .sidebar-main {
              position: fixed;
              top: 0;
              left: -280px;
              height: 100vh;
              z-index: 1001;
            }
          }
            .dashboard-row {
    flex-wrap: wrap;   /* 🔥 allow wrap on small screens */
  }

  @media (max-width: 768px) {
    .row {
      margin-top: 20px !important;
    }

    select {
      min-height: 42px;
    }
  }
  @media (min-width: 1025px) {
    .mobile-close-icon {
      display: none !important;
    }
  }

  .u-cal-days-grid .day {
    height: 42px;
    width: 42px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
  }


  @media (max-width: 768px) {
    .u-cal-card {
      width: 100% !important;
    }
  }
  @media (max-width: 768px) {

    .card {
      padding: 10px !important;
    }

    h4 {
      font-size: 14px;
    }

    .content {
      padding: 10px !important;
    }
  }
  @media (max-width: 1024px) {
    .sidebar-main {
      position: fixed;
      width: 240px !important;
    }
  }


  /* 🟢 Present */
  .u-cal-days-grid .present {
    background: #43919B;
    color: white;
  }

  /* 🔴 Absent */
  .u-cal-days-grid .absent {
    background: #D61C4E;
    color: white;
  }

  @keyframes pulseHint {
    0% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.03); opacity: 0.85; }
    100% { transform: scale(1); opacity: 1; }
  }

  /* COMMON DAY BOX */
  .u-day {
    height: 42px;
    width: 42px;

    display: flex;
    align-items: center;
    justify-content: center;

    font-weight: 800;
    cursor: pointer;

    transition: all .2s ease;
  }

  /* 🔵 PAST DATE → NORMAL me SIMPLE */
  .u-past {
    color: #3B44F6;
    border: none;            /* ❌ default me border nahi */
  }

  /* DAY BOX */
  .u-day{
    height:46px;
    width:46px;

    border-radius:16px;

    background:
    linear-gradient(145deg,#fff,#f1f5ff);

    font-weight:900;
  }

  /* FUTURE HOVER */
  .u-future:hover{
    border-radius:50%;

    background:
    linear-gradient(
    135deg,
    #e0e7ff,
    #ddd6fe,
    #fce7f3);

    border:2px dashed #A149FA;

    box-shadow:
    0 0 16px rgba(168,85,247,.35);
  }

  /* ✨ HOVER EFFECT ONLY PAST PAR */
  .u-past:hover {
    border: 2px solid #3B44F6;   /* ✅ hover par blue circle */
    border-radius: 50%;
    background: #ebf4ff;
  }

  /* ✨ GENERAL HOVER */
  .u-day:hover {
    transform: scale(1.08);
  }

  /* ✨ FUTURE DATE HOVER → CIRCLE EFFECT */
  .u-future:hover {
    border-radius: 50%;
    background: linear-gradient(135deg,#e0e7ff,#c7d2fe);
    color: #3B44F6;
    border: 2px dashed #A149FA;
    box-shadow: 0 0 14px rgba(99,102,241,.3);
    transform: scale(1.12);
  }


  /* ===== TODAY DATE STYLE ===== */
  .u-today {
    border-bottom: 3px solid #548CFF !important;
    font-weight: 900;
    background: #f0f7ff;
  }

  /* Hover par circle bhi ho jaye */
  .u-today:hover {
    border-radius: 50%;
    background: #548CFF;
    color: white;
  }


  .u-cal-card{
    background:
    linear-gradient(
      160deg,
      rgba(255,255,255,.95),
      rgba(240,245,255,.95)
    );

    backdrop-filter:blur(14px);

    border-radius:28px;

    box-shadow:
    0 20px 40px rgba(0,0,0,.08),
    inset 0 0 0 1px rgba(99,102,241,.12);
  }

  /* HEADER */
  .u-cal-months-header{
    background:
    linear-gradient(
    135deg,
   #9254C8,#C32BAD,#FF67E7);

    color:white;
    padding:22px;
    border-radius:28px 28px 0 0;
  }

  /* ===== BASE DAY STYLE ===== */
  .u-day {
    height: 46px;
    width: 46px;
    border-radius: 16px;

    display: flex;
    align-items: center;
    justify-content: center;

    font-weight: 900;
    cursor: pointer;

    background: linear-gradient(145deg,#fff,#f1f5ff);

    transition: all .2s ease;
  }

  /* 🟢 PRESENT DAY */
  .u-present {
    color: #16a34a !important;      /* GREEN NUMBER */
    font-weight: 900;
  }

  /* 🔴 ABSENT DAY */
  .u-absent {
    color: #dc2626 !important;      /* RED NUMBER */
    font-weight: 900;
  }

  /* ===== HOVER CIRCLE FOR ALL ===== */
  .u-day:hover {
    border-radius: 16px ;
    transform: scale(1.1);
  }

  /* 🟢 PRESENT + HOVER */
  .u-present:hover {
    background: #16a34a !important;   /* GREEN CIRCLE */
    color: white !important;          /* WHITE NUMBER */
    box-shadow: 0 0 14px rgba(22,163,74,.35);

  }

  /* 🔴 ABSENT + HOVER */
  .u-absent:hover {
    background: #dc2626 !important;   /* RED CIRCLE */
    color: white !important;
    box-shadow: 0 0 14px rgba(220,38,38,.35);
  }

  /* ===== TODAY STYLE ===== */
  .u-today {
    border-bottom: 3px solid #3b82f6 !important;
    background: #f0f7ff;
  }

  /* TODAY + HOVER */
  .u-today:hover {
    border-radius: 50% !important;
  }

  // ------------------------------all combine graphs report chart------------------

  :root {
    --p: #6366f1;
    --s: #ec4899;
    --dark: #0f172a;
    --light: #f8fafc;

    --card: linear-gradient(145deg,#ffffff,#f8faff);
    --glass: rgba(255,255,255,.75);
  }

  * {
    box-sizing: border-box;
    font-family: "Poppins", sans-serif;

  }

  /* LAYOUT */
  .app {
    display: flex;
    min-height: 100vh;
    background: #f4f5fa;
  }



  /* MAIN */
  .main {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  /* TOPBAR */
  .topbar {
    background: #fff;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  }

  .topbar span {
    font-size: 13px;
    color: #666;
  }

  /* DOTS */
  .status-dots span {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    display: inline-block;
    margin-left: 8px;
  }

  .green { background: #22c55e; }
  .blue { background: #3b82f6; }
  .yellow { background: #eab308; }
  .pink { background: #ec4899; }

  /* CONTENT */
  .content {
    padding: 20px;
  }

  /* GRID */
 .grid-2 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
  gap: 20px;
}
.grid-2 > .card:only-child {
  grid-column: 1 / -1;
}


  @media (max-width: 992px) {
    .grid-2 {
      grid-template-columns: 1fr;
    }
  }


  /* CARD */
  .card {
    background: #fff;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0,0,0,0.08);
    margin-bottom: 20px;
  }

  .card h4 {
    margin-bottom: 10px;
  }


  /* ================= RESPONSIVE ================= */

  /* TABLET */
  @media (max-width: 1024px) {
    .sidebar {
      width: 180px;
      padding: 15px;
    }

    .grid-2 {
      grid-template-columns: 1fr;
    }
  }

  /* MOBILE */
  @media (max-width: 768px) {

    .app {
      flex-direction: column;
    }

    /* SIDEBAR → TOP */
    .sidebar {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .sidebar nav {
      display: flex;
      gap: 12px;
    }

    .sidebar nav a {
      margin: 0;
      padding: 8px 10px;
      font-size: 14px;
    }

    /* TOPBAR STACK */
    .topbar {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }

    /* CONTENT */
    .content {
      padding: 15px;
    }

    .card {
      margin-bottom: 15px;
    }
  }

  /* SMALL MOBILE */
  @media (max-width: 480px) {

    .sidebar h2 {
      font-size: 18px;
    }

    .sidebar nav a {
      font-size: 12px;
      padding: 6px 8px;
    }

    .card h4 {
      font-size: 14px;
    }
  }


  @keyframes fillRing {
    from {
      stroke-dashoffset: 100%;
    }
    to {
      stroke-dashoffset: var(--dash-end);
    }
  }

  .card {
    background: linear-gradient(145deg,#ffffff,#f8faff);
    border-radius: 18px;
    box-shadow: 0 10px 24px rgba(0,0,0,.06);
    transition: .3s;
  }

  .card:hover {
    transform: translateY(-3px);
  }

  h4 {
    font-weight: 800;
    color: #1e293b;
  }

  .graph-container {
    width: 100%;
    height: 260px;
    min-width: 0;
  }

  @media (max-width: 600px) {
    .graph-container {
      height: 220px;
    }
  }


  .recharts-bar-rectangle {
    rx: 6px;              /* rounded bars */
  }

  .recharts-tooltip-wrapper {
    border-radius: 12px !important;
    box-shadow: 0 10px 20px rgba(0,0,0,.15) !important;
  }

  /* 🔥 REMOVE BAR BACKGROUND & SHADOW */
  .recharts-bar-background-rectangle {
    display: none !important;
  }

  .recharts-rectangle {
    filter: none !important;
    box-shadow: none !important;
    
  }

  .recharts-bar-rectangle {
    filter: none !important;
  }


  /* ===== OVERALL REPORT WHITE PANEL ===== */

  .whitePanel {
    
    border-radius: 999px;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    gap: 20px;
    flex-wrap: nowrap;
    box-shadow: 0 8px 20px rgba(0,0,0,.12);
  }

  /* DESKTOP OK */

  /* ===== MOBILE FIX ===== */
  @media (max-width: 768px) {

    .whitePanel {
      width: 100% !important;
      border-radius: 16px !important;   /* pill se card ban jayega */
      flex-wrap: wrap !important;
      justify-content: center !important;
      gap: 12px !important;
      padding: 12px !important;
    }

    .statBox {
      min-width: 80px !important;
    }

    .bigNumber {
      font-size: 15px !important;
    }

    .verdictText {
      font-size: 12px !important;
    }

    .dotRow {
      width: 100%;
      justify-content: center;
      margin-top: 6px;
    }
  }

  /* ===== TOTAL QUALITY RESPONSIVE ===== */

  .quality-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 24px;
    flex-wrap: wrap;
    width: 100%;
  }

  .ring-box {
    width: 260px;
    height: 260px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .quality-svg {
    width: 100%;
    height: 100%;
  }

  .quality-labels {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .quality-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 800;
  }

  .color-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }

  .q-label {
    color: #0f172a;
  }

  .q-value {
    font-weight: 900;
  }

  /* ===== MOBILE FIX ===== */

  @media (max-width: 768px) {

    .ring-box {
      width: 200px !important;
      height: 200px !important;
    }

    .quality-wrapper {
      flex-direction: column !important;
    }

    .quality-labels {
      align-items: center;
    }

    .quality-item {
      font-size: 13px;
    }
  }

  /* ===== CHHOTA PHONE ===== */

  @media (max-width: 420px) {

    .ring-box {
      width: 170px !important;
      height: 170px !important;
    }

    .quality-item {
      font-size: 12px;
    }
  }


  /* ===== DEFAULT (DESKTOP) ===== */
  .mobile-only {
    display: none !important;   /* desktop me hamburger hide */
  }

  .desktop-menu {
    display: flex !important;   /* desktop me header items show */
  }

  /* ===== MOBILE RESPONSIVE ===== */
  @media (max-width: 1024px) {

    .mobile-only {
      display: block !important;   /* mobile me hamburger show */
    }

    .desktop-menu {
      display: none !important;    /* mobile me header items hide */
    }

    /* sidebar already aapke code me hai wo sahi hai */
  }

  /* ===== CALENDAR FIX ===== */

  .u-cal-container {
    width: 100%;
    display: flex;
    justify-content: center;
    // overflow-x: hidden;
  }

  /* ===== FULL WIDTH + EQUAL HEIGHT FIX ===== */

  .u-cal-container {
    width: 100% !important;
    height: 100% !important;
    display: flex;
  }

  .u-cal-card {
    width: 600px;
    height: 310px;        
    margin: 0 !important;

    display: flex;
    flex-direction: column;
  }

  /* days area ko bhi stretch */
  .u-cal-days-grid {
    flex: 0.5;
  }

  .u-cal-days-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 6px;
    padding: 8px;
  }

  .u-day {
    width: 100% !important;
    aspect-ratio: 1 / 1;
    height: 30px !important;
  }

  /* MOBILE */
  @media (max-width: 768px) {

    

    .u-day {
      font-size: 12px;
    }

    .reportDropdown {
      max-height: 180px !important;
    }
  }


  /* ===== SPIDER NEW LAYOUT ===== */

  .spider-layout {
    display: grid;
    grid-template-columns: 260px 1fr;
    gap: 20px;
    margin-top: 10px;
  }

  /* LEFT */
  /* ===== FILTER CARD ===== */

  .spider-filter {
    background: linear-gradient(145deg,#ffffff,#f8faff);
    border-radius: 18px;
    padding: 18px;
    box-shadow: 0 12px 26px rgba(0,0,0,.08);
    border: 1px solid rgba(99,102,241,.12);
  }

  /* LABEL */
  .spider-label {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: .5px;
    background: linear-gradient(90deg,#6366f1,#ec4899);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

  }

  /* ===== PREMIUM DROPDOWN ===== */

  .spider-select {
    width: 100%;
    margin-top: 8px;

    padding: 12px 14px;
    border-radius: 14px;

    border: 1px solid #e2e8f0;

    background:
      linear-gradient(145deg,#ffffff,#f3f6ff);

    font-weight: 600;
    font-size: 13px;
    color: #0f172a;

    appearance: none;

    background-image:
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%236366f1' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");

    background-repeat: no-repeat;
    background-position: right 12px center;

    transition: .25s ease;
    cursor: pointer;

    box-shadow: 0 6px 14px rgba(99,102,241,.08);
  }

  /* HOVER */
  .spider-select:hover {
    border-color: #6366f1;
    box-shadow: 0 8px 20px rgba(99,102,241,.18);
  }

  /* FOCUS */
  .spider-select:focus {
    outline: none;

    border-color: #ec4899;

    box-shadow:
      0 0 0 3px rgba(236,72,153,.2),
      0 10px 22px rgba(236,72,153,.2);
  }

  /* OPTIONS */
  .spider-select option {
    padding: 10px;
    font-weight: 500;
    color: #0f172a;
  }

  /* INFO BOX */
  .spider-info {
    margin-top: 12px;

    font-size: 12px;
    font-weight: 500;

    color: #475569;

    background:
      linear-gradient(145deg,#eef2ff,#f8faff);

    padding: 10px;
    border-radius: 12px;

    border: 1px dashed rgba(99,102,241,.25);
  }


  /* RIGHT */
  .spider-chart {
    width: 100%;
    max-width: 1100px;
    margin: 0 auto;
    text-align: center;
    padding: 10px;
  }
  .recharts-polar-angle-axis text {
    dominant-baseline: middle;
  }

  .recharts-polar-angle-axis tspan {
    white-space: normal !important;
  }

  .recharts-surface {
    overflow: visible !important;
  }

  .recharts-wrapper {
    overflow: visible !important;
  }



  /* MOBILE */
  @media (max-width: 900px) {
    .spider-layout {
      grid-template-columns: 1fr;
    }
  }


  /* ===== MAIN SPLIT ===== */
  .matrix-layout {
    display: grid;
    grid-template-columns: 280px 1fr;
    gap: 16px;
    margin-top: 10px;
  }

  /* ===== LEFT PANEL ===== */
  .matrix-left {
    max-height: 460px;
    overflow-y: auto;
  }

  /* ===== RIGHT PANEL ===== */
  .matrix-right {
    background: #fff;
    border-radius: 16px;
  }

  /* ===== GRAPH SCROLL ===== */
  .graph-scroll {
    width: 100%;
    height: 460px;
    overflow-y: auto;
    padding-right: 6px;
  }

  /* MOBILE */
  @media (max-width: 900px) {
    .matrix-layout {
      grid-template-columns: 1fr;
    }

    .matrix-left {
      max-height: 260px;
    }
  }

  /* ===== LEGEND BOX ===== */
  .matrix-legend {
    margin-top: 12px;
    padding: 10px;
    border-radius: 14px;
    background: linear-gradient(145deg,#f8faff,#ffffff);
    border: 1px solid rgba(99,102,241,.18);
  }

  /* TITLE */
  .legend-title {
    font-size: 12px;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 6px;
  }

  /* ROW */
  .legend-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
  }

  /* BADGE = REAL COLOR SHOW */
  .badge {
    min-width: 70px;
    padding: 4px 8px;
    border-radius: 10px;
    font-size: 11px;
    font-weight: 700;
    text-align: center;
    color: #fff;
  }

  /* TEXT */
  .legend-text {
    font-size: 12px;
    color: #475569;
  }

  /* COLORS SAME AS GRAPH */
  .badge.green { background: #22c55e; }
  .badge.blue { background: #3b82f6; }
  .badge.yellow { background: #facc15; color:#000; }
  .badge.red { background: #ef4444; }



  .graph-card {
    padding: 20px;
  }

  .graph-wrapper {
    width: 100%;
    height: 320px;
    margin-top: 10px;
  }

  .no-data {
    padding: 20px;
    font-weight: 500;
    color: #64748b;
  }

  /* MOBILE */
  @media (max-width: 768px) {
    .graph-wrapper {
      height: 260px;
    }
  }

  // ------------------------------all combine graphs report chart------------------

  /* ===== MAIN SCROLL CONTAINER ===== */
  .time-table-container {
    height: 320px;               /* FIX HEIGHT */
    max-height: 320px;
    overflow-y: auto;            /* 🔥 SCROLL */
    overflow-x: hidden;

    padding-right: 8px;

    scrollbar-width: thin;       /* firefox */
    scrollbar-color: #c7d2fe #f1f5f9;
  }

  /* CHROME SCROLL DESIGN */
  .time-table-container::-webkit-scrollbar {
    width: 6px;
  }

  .time-table-container::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
  }

  .time-table-container::-webkit-scrollbar-thumb {
    background: #c7d2fe;
    border-radius: 10px;
  }

  /* ===== ROW DESIGN ===== */
  .time-row {
    display: grid;
    grid-template-columns: 1.6fr 2.4fr 60px;
    align-items: center;
    gap: 12px;

    padding: 8px 6px;
    border-bottom: 1px solid #f1f5f9;
  }

  .topic-name {
    font-size: 12px;
    font-weight: 600;
    color: #1e293b;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .bar-area {
    background: #f1f5f9;
    border-radius: 10px;
    height: 10px;
    width: 100%;
    overflow: hidden;
  }

  .mini-bar {
    height: 100%;
    border-radius: 10px;
    transition: .4s ease;
  }

  .min-label {
    font-size: 12px;
    font-weight: 700;
    text-align: right;
  }

  /* ===== MOBILE ===== */
  @media (max-width: 768px) {

    .time-table-container {
      height: 260px;
    }

    .time-row {
      grid-template-columns: 1.4fr 2.6fr 50px;
    }

    .topic-name {
      font-size: 11px;
    }
  }

  /* Default (Desktop) */
  .scatter-scroll-wrapper {
    width: 100%;
  }

  /* Mobile Only */
  @media (max-width: 768px) {
    .scatter-scroll-wrapper {
      overflow-x: auto;
    }

    .scatter-scroll-wrapper .scatter-inner {
      min-width: 1000px; /* 🔥 controls scroll width */
    }
  }


  .bar-scroll-wrapper {
  -webkit-overflow-scrolling: touch; /* smooth mobile scroll */
}

.bar-scroll-wrapper::-webkit-scrollbar {
  height: 6px;
}

.bar-scroll-wrapper::-webkit-scrollbar-thumb {
  background: linear-gradient(90deg, #6366f1, #22c55e);
  border-radius: 10px;
}

.quality-wrapper {
  display: flex;
  align-items: center;
  gap: 30px;
}

.quality-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.color-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
}

.quality-svg {
  width: 280px;
  height: 280px;
}

@media (min-width: 768px) {
  .bar-scroll-wrapper {
    overflow-x: hidden !important;
  }

  .bar-scroll-wrapper > div {
    min-width: 100% !important;
  }
}

/* ===== DEFAULT DESKTOP ===== */
.spider-scroll-wrapper {
  width: 100%;
  overflow-x: hidden;     /* 🔥 desktop me scroll hide */
}

.spider-inner {
  width: 100%;
}

/* ===== MOBILE ONLY ===== */
@media (max-width: 768px) {

  .spider-scroll-wrapper {
    overflow-x: auto;      /* 🔥 mobile me scroll enable */
    -webkit-overflow-scrolling: touch;
  }

  .spider-inner {
    min-width: 650px;      /* 🔥 scroll trigger width */
  }
}


@keyframes glowPulse {
  0%   { box-shadow: 0 0 8px currentColor; }
  50%  { box-shadow: 0 0 20px currentColor; }
  100% { box-shadow: 0 0 8px currentColor; }
}


animation: isActive ? "glowPulse 1.5s infinite" : "none",



// ---------------------------badges----------------------
/* ===== BADGE WRAPPER ===== */
.badge-wrapper {
  width: 100%;
  margin-top: 40px;
}

/* ===== RESPONSIVE GRID ===== */
.badge-strip {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 24px;
  padding: 10px 10px;
  justify-items: center;
}

/* ===== CARD ===== */
.badge-card {
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.3s ease;
 border-radius: 28px;
}

.badge-card:hover {
  transform: scale(1.05);
}

/* ===== LIQUID BOX ===== */
.liquid-wrapper {
  position: relative;
  width: 150px;
  height: 150px;
  border-radius: 28px;
  overflow: hidden;
  background: linear-gradient(145deg,#e5e7eb,#cbd5e1);
}

/* FILL */
.liquid-fill {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  transition: height 0.8s ease;
  z-index: 1;
}

/* IMAGE */
.badge-image {
  position: absolute;
  top: 20px;              /* 🔥 top gap */
  left: 50%;
  transform: translateX(-50%);  /* 🔥 perfectly center */
  width: 125px;
  z-index: 2;
}

/* PERCENT */
.badge-percent {
  position: absolute;
  bottom: 15px;
  left: 52%;
  transform: translateX(-50%);
  background: rgba(0,0,0,0.75);
  color: white;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  z-index: 3;
}

/* ===== TABLET ===== */
@media (max-width: 1024px) {
  .liquid-wrapper {
    width: 120px;
    height: 120px;
  }

  .badge-image {
    width: 100px;
  }
}

/* ===== MOBILE ===== */
@media (max-width: 768px) {
  .badge-strip {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .liquid-wrapper {
    width: 110px;
    height: 110px;
  }

  .badge-image {
    width: 90px;
  }
}

/* ===== SMALL PHONE ===== */
@media (max-width: 480px) {
  .badge-strip {
    grid-template-columns: repeat(2, 1fr);
  }

  .liquid-wrapper {
    width: 95px;
    height: 95px;
  }

  .badge-image {
    width: 80px;
  }

  .badge-percent {
    font-size: 10px;
  }
}



/* 🔥 100% Badge Glow */
.badge-card.unlocked {
  animation: glowBadge 2s infinite alternate;
}

@keyframes glowBadge {
  from {
    box-shadow: 0 0 15px rgba(168,85,247,.4);
  }
  to {
    box-shadow: 0 0 30px rgba(168,85,247,.8);
  }
}



.dashboard-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 24px;
  margin-top: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
}

.section-title {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #1e293b;
}

.badges-card {
  position: relative;
  overflow: hidden;
}
 

.badges-header {
  display: flex;
  align-items: center;
  justify-content: flex-start; /* left align */
  margin-bottom: 20px;
}

.badges-header h2 {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
}
// ---------------------------badges----------------------




// ------------------------lock------------------
/* ===== OVERALL LOCK PREMIUM ===== */

.overall-lock {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
}

.overall-lock-content {
  background: rgba(255,255,255,0.08);
  padding: 40px 50px;
  border-radius: 20px;
  text-align: center;
  color: white;
  max-width: 420px;
  backdrop-filter: blur(20px);
  box-shadow: 0 20px 50px rgba(0,0,0,0.35);
  border: 1px solid rgba(255,255,255,0.15);
}

.overall-lock-content h3 {
  margin-top: 12px;
  font-weight: 800;
  font-size: 22px;
}

.overall-lock-content p {
  margin: 10px 0 25px;
  font-size: 14px;
  opacity: 0.85;
}

/* Button Style */
.overall-unlock-btn {
  padding: 12px 28px;
  border-radius: 30px;
  border: none;
  font-weight: 800;
  cursor: not-allowed;
  background: linear-gradient(135deg,#9254C8,#C32BAD,#FF67E7);
  color: #fff;
  opacity: 0.7;
  box-shadow: 0 10px 25px rgba(168,85,247,.4);
}

/* Blur Background */
.overall-blur {
  filter: blur(6px);
  pointer-events: none;
}
  .badge-card.unlocked .liquid-wrapper {
  box-shadow: 0 0 25px rgba(168,85,247,.5);
}




// ------------------------lock------------------4


// .certificate-flag{
//   position: absolute;
//   top: 10px;
//   right: 10px;
//   background: linear-gradient(135deg,#22c55e,#16a34a);
//   color: white;
//   font-size: 11px;
//   font-weight: 700;
//   padding: 5px 10px;
//   border-radius: 999px;
//   z-index: 10;
//   box-shadow: 0 4px 12px rgba(34,197,94,0.35);
//   animation: pulseFlag 1.8s infinite;
// }

// @keyframes pulseFlag{
//   0%{
//     transform: scale(1);
//   }
//   50%{
//     transform: scale(1.06);
//   }
//   100%{
//     transform: scale(1);
//   }
// }

        `}</style>
);

export default DashboardStyles02;